import React from 'react';
import styled from '@emotion/styled';

const BadgeStyled = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 14px;
  border-radius: 999px;
  background: #efe9ff;
  color: #6c3bff;
  font-size: 13px;
  font-weight: 600;

  ${props => props.variant === 'soft' && `
    background: #f3efff;
    color: #7a58e6;
  `}

  ${props => props.variant === 'primary' && `
    background: #efe9ff;
    color: #6c3bff;
  `}

  ${props => props.variant === 'blue' && `
    background: #eef4ff;
    color: #4f7efb;
  `}
`;

const ZfBadge = ({ children, variant = 'primary', ...props }) => {
  return (
    <BadgeStyled variant={variant} {...props}>
      {children}
    </BadgeStyled>
  );
};

export default ZfBadge;
